@if(canScroll()){
<button class="scroll-cta scroll-up btn btn-outline-light" (click)="handleScrollUp()" [disabled]="cantScrollUp">
  <img src="assets/icons/arrow-down.svg" alt="">
</button>
}

<div #scroll class="media-selector">

  @for( image of images();let i = $index; track $index){
  <button class="btn btn-outline-light" [class.selected]="selectedMedia() === image" (click)="handleSelectImage(i)">
    <img [attr.src]="image" alt="" (error)="handleOnError(i)">
  </button>
  }

</div>

@if(canScroll()){
<button class="scroll-cta scroll-down btn btn-outline-light" (click)="handleScrollDown()" [disabled]="cantScrollDown">
  <img src="assets/icons/arrow-down.svg" alt="">
</button>
}
